import type {SystemStyleObject} from '@chakra-ui/system';
import {createStylesContext} from '@chakra-ui/system';

import type {Part} from './anatomy';

const ComponentName = `FiltersContext` as const;

export const [StylesProvider, _useStyles] = createStylesContext(ComponentName);

export const useStyles = _useStyles as () => Record<Part, SystemStyleObject>;
